import {HttpClient} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {MatCard, MatCardTitle} from '@angular/material/card';
import {MatButton} from '@angular/material/button';
import {MatFormField, MatLabel, MatInput} from '@angular/material/input';
import {FormsModule} from '@angular/forms';
import {MatCheckbox} from '@angular/material/checkbox';

@Component({
    selector: 'aw-feature-testing',
    templateUrl: './feature-testing.component.html',
    styleUrls: ['./feature-testing.component.less'],
    imports: [MatCard, MatCardTitle, MatButton, MatFormField, MatLabel, MatInput, FormsModule, MatCheckbox]
})
export class FeatureTestingComponent implements OnInit {
    tests: any[];
    testBeingEdited: any;

    constructor(private readonly http: HttpClient    ) {    }

    ngOnInit(): void {
        this.getTests();
    }

    getTests() {
        this.http.get<any[]>("/api/feature-test-config/all")
            .subscribe(tests => this.tests = tests);
    }

    save(test) {
        if (test.TestId && test.TestId > 0) {
            this.http.post<any[]>("/api/feature-test-config/" + test.TestId.toString(), test)
                .subscribe(result => {
                    this.testBeingEdited = undefined;
                    this.getTests();
                });
        } else {
            this.http.post<any[]>("/api/feature-test-config/", test)
                .subscribe(result => {
                    this.testBeingEdited = undefined;
                    this.getTests();
                });
        }
    }
}
